// extracted by mini-css-extract-plugin
export default {"content-text":"ConfirmDialog_content-text__d9Fsr","confirm-button":"ConfirmDialog_confirm-button__JrbXb","cancel-button":"ConfirmDialog_cancel-button__SE0qZ"};